'use strict';
import {CurrentPositionObservable} from './CurrentPositionObservable';
import {WatchPositionObservable} from './WatchPositionObservable';

export const geolocation = {
  currentPosition: options => {
    geolocationExists();
    return new CurrentPositionObservable(options);
  },
  watchPosition: options => {
    geolocationExists();
    return new WatchPositionObservable(options);
  },
};

function geolocationExists() {
  if (!global.window.navigator || !global.window.navigator.geolocation) {
    throw new TypeError('geolocation not available');
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/rx-dom/index.js